import React from 'react';
import { Modal, List, Button, Typography } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { config } from '../../config';

/**
 * Opens a catalog item in the editor: loads the full catalog (incl. hidden /
 * not-ready items via `loadAllCatalog`) and adds the chosen variant.
 * `itemId` = catalog item id, `variantId` = catalog variant id.
 */
export const openInEditor = (itemId, variantId) => {
    const { clientBaseUrl } = config();
    window.open(
        `${clientBaseUrl}/editor?loadAllCatalog&addItem=${variantId}&itemId=${itemId}`,
        '_blank',
        'noopener,noreferrer',
    );
};

/**
 * Variant picker for "open in editor". Use `openOrSelect` to open directly when
 * there's a single variant, else render this modal to choose which to load.
 * `variants`: [{ id, label }].
 */
export const VariantSelectorModal = ({ open, itemId, title, variants, onClose }) => (
    <Modal title={`Open in editor — ${title || ''}`} open={open} onCancel={onClose} footer={null} width={400}>
        <List
            dataSource={variants || []}
            renderItem={(variant, index) => (
                <List.Item
                    key={variant.id}
                    actions={[
                        <Button
                            type="primary"
                            size="small"
                            icon={<EyeOutlined />}
                            onClick={() => {
                                openInEditor(itemId, variant.id);
                                onClose();
                            }}
                        >
                            Open
                        </Button>,
                    ]}
                >
                    <Typography.Text>{variant.label || `Variant ${index + 1}`}</Typography.Text>
                </List.Item>
            )}
        />
    </Modal>
);
